import React, { useEffect, useMemo, useState } from 'react';
import { Box, Card, CardContent, Typography, IconButton, Button, TextField, Chip, Tabs, Tab, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, useTheme, Menu, MenuItem, InputAdornment } from '@mui/material';
import { PlayArrow, GridView, TableView, MoreVert } from '@mui/icons-material';
import useAxios from 'packages/novous_web/src/api/useAxios';
import { API_ENDPOINTS } from 'packages/novous_web/src/api/endpoints';
import { useAuth } from "packages/novous_web/src/authContext/useAuth";
import axiosInstance from "../../../../api/apiClient";
import { useLocation, useNavigate } from 'react-router-dom';
import AlertsGrid from '../../Alarm/Vehicle-Alerts/components/AlertDataGrid';
import AlertsTable from '../../Alarm/Vehicle-Alerts/components/AlertDataTable';
import CallMadeIcon from '@mui/icons-material/CallMade';
import CustomIconButton from 'packages/novous_web/src/common/components/CustomIconButton';
import Custom from 'packages/novous_web/src/assets/icons/CustomBlue.svg'
import calendar from "packages/novous_web/src/assets/icons/calendar.svg";
import DateRangeFilter from 'packages/novous_web/src/common/components/DateRange';
import dayjs from 'dayjs';
import arrow from "packages/novous_web/src/assets/icons/Arrow.svg";
import searchIcon from 'packages/novous_web/src/assets/icons/Icon.svg'
import filterIcon from 'packages/novous_web/src/assets/icons/Filter.svg'
import { getWarningIcon } from '../../Alarm/Vehicle-Alerts/helper/warningIcons';
import CustomiseTableModal from 'packages/novous_web/src/common/components/CustomiseTable';
import { MRT_ColumnDef } from 'material-react-table';
import infoIcon from "../../../../assets/icons/i.svg";
import useDebounce from 'packages/novous_web/src/hooks/useDebounce';
import FilterDataModel from 'packages/novous_web/src/common/components/FilterDataModal';

interface Alert {
    id: string;
    driverName: string;
    vehicleNumber: string;
    timestamp: string;
}

interface WarningData {
    warningName: string;
    alerts: Alert[];
}

type ColumnObjType = {
    [key: string]: {
        name: string;
        status: boolean;
    };
};
interface AlertDataTableProps {
    handleTile: (data: ColumnObjType) => void;
    setEndTileDate?: any;
    setStartTileDate?: any;
}
const TripAlerts = ({ tripDetails, isCalledFromTrip = false }: any) => {
    console.log('tripDetails', tripDetails);
    const theme = useTheme();
    console.log('   xsnxjn xskxkx skx qxs kqqkx xqx xqm xkqx xqkq')
    const { user } = useAuth();
    const location = useLocation();
    const state = location.state || {};
    console.log('state', state);
    const [warnings, setWarnings] = useState<any>(null);
    const [criticalWarning, setCriticalWarning] = useState<any>([]);
    const [nonCriticalWarning, setNonCriticalWarning] = useState<any>([]);
    const [alertsMap, setAlertsMap] = useState<{ [key: string]: { alerts: any[] } }>({});
    const [warningType, setWarningType] = useState<any>();
    const alertsDataArr: any = [];
    const [allWarningTypes, setAllWarningTypes] = useState<any>([]);
    const [newData, setNewData] = useState<WarningData[]>([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [calendarAnchorEl, setCalendarAnchorEl] = useState<null | HTMLElement>(
        null
    );
    const [searchQuery, setSearchQuery] = useState('');
    const debouncedSearchQuery = useDebounce(searchQuery, 500);
    const [filteredData, setFilteredData] = useState<any>();
    const [showDatePicker, setShowDatePicker] = useState(false);
    const [startDate, setStartDate] = useState(state?.startDate || "");
    const [endDate, setEndDate] = useState(state?.endDate || "");
    const dateRangeArr = [
        "Today",
        "Yesterday",
        "7 Days",
        "15 Days",
        "30 Days",
        "Custom Range",
    ];
    const [selectedDuration, setSelectedDuration] = useState(state?.selectedDuration || dateRangeArr[0]);
    const { data: alert1Data, fetchData: fetch1AlertData } = useAxios<any>(
        `${API_ENDPOINTS.alarm.VEHICLE_ALERT_ALL_WARNING}`,
        "POST"
    );
    const [isFilterModel, setIsFilterModelOpen] = useState(false);
    const [activeTab, setActiveTab] = useState<'all' | 'critical' | 'nonCritical'>('all');
    const [viewMode, setViewMode] = useState<'grid' | 'table'>(state.viewMode || 'grid');
    const navigate = useNavigate(); // Add from react-router-dom
    const handleFilterClose = () => setIsFilterModelOpen(false);
    const handleFilterOpen = () => setIsFilterModelOpen(true);
    useEffect(() => {
        if (user?.customer_id) {
            fetch1AlertData({ fleetId: user.customer_id, startDate: '2025-03-01', endDate: '2025-03-22' });
        }
    }, [user]);

    useEffect(() => {
        if (alert1Data?.data) {
            setWarnings(alert1Data.data);
            setCriticalWarning(alert1Data.data.criticalWarningType || []);
            setNonCriticalWarning(alert1Data.data.nonCriticalWarningType || []);
            setAllWarningTypes([...(alert1Data.data.criticalWarningType || []), ...(alert1Data.data.nonCriticalWarningType || [])]);
        }
    }, [alert1Data]);
    useEffect(() => {
        if (activeTab === 'all') {
            fetchAllAlertsParallel(allWarningTypes);
        } else if (activeTab === 'critical') {
            fetchAllAlertsParallel(criticalWarning);
        } else if (activeTab === 'nonCritical') {
            fetchAllAlertsParallel(nonCriticalWarning);
        }
    }, [activeTab, allWarningTypes, criticalWarning, nonCriticalWarning]);
    useEffect(() => {
        const { startDate: newStartDate, endDate: newEndDate } = getDateRange(selectedDuration);
        setStartDate(newStartDate);
        // setStartTileDate(newStartDate);
        // setEndTileDate(newEndDate);
        setEndDate(newEndDate);
    }, [selectedDuration]);
    const combineDateTime = (dateStr: string, timeStr: string): string => {
        const [hours, minutes, seconds = '00'] = timeStr.split(':');
        return `${dateStr}:${hours}:${minutes}:${seconds}`;
      };
      
    const fetchAllAlertsParallel = async (warningTypes: string[], vehicleGroup?: string, vehicleId?: string) => {
        try {
            setLoading(true);
            setError(null);
                      let ignitionBasedStartTime = "";
            let ignitionBasedEndTime = "";
            
            if (isCalledFromTrip && tripDetails?.tripDetails) {
                // If called from a trip, use tripDetails.tripDetails for start and end times
                ignitionBasedStartTime = combineDateTime(
                    tripDetails.tripDetails.departureDate,
                    tripDetails.tripDetails.departureTime
                );
                ignitionBasedEndTime = combineDateTime(
                    tripDetails.tripDetails.arrivalDate,
                    tripDetails.tripDetails.arrivalTime
                );
            } else if (tripDetails) {
                // If not called from a trip, use tripDetails directly
                ignitionBasedStartTime = combineDateTime(
                    tripDetails.departureDate,
                    tripDetails.departureTime
                );
                ignitionBasedEndTime = combineDateTime(
                    tripDetails.arrivalDate,
                    tripDetails.arrivalTime
                );
            }
            console.log("Ignition Based Start Time:", ignitionBasedStartTime);
            console.log("Ignition Based End Time:", ignitionBasedEndTime);
            
            // Set the start and end dates
            setStartDate(ignitionBasedStartTime);
            setEndDate(ignitionBasedEndTime);
            
            console.log("Start Date:", ignitionBasedStartTime);
            console.log("End Date:", ignitionBasedEndTime);
            console.log("tripDetails?.vehicleId:", tripDetails?.vehicleId);
            const requests = warningTypes.map(warningType =>
                axiosInstance({
                    url: API_ENDPOINTS.alarm.VEHICLE_ALL_ALERTS_BY_WARNING,
                    method: "POST",
                    data: {
                        fleetId: user?.customer_id,
                        startDate: ignitionBasedStartTime,
                        endDate: ignitionBasedEndTime,
                        warningType,
                        lastEvaluatedKey: null,
                        ...(vehicleGroup && { vehicleGroup: vehicleGroup }),
                        vehicleId: vehicleId ?? tripDetails?.vehicleId ?? tripDetails?.tripDetails?.vehicleId,
                    },
                    responseType: "json"
                }).then(response => ({
                    warningName: warningType,
                    alerts: response.data || [],
                })).catch(error => ({
                    warningName: warningType,
                    alerts: [],
                    error: error.message
                }))
            );
                
            const results = await Promise.all(requests);
            console.log("Results:", results);
            let filteredDataArr = [];
            filteredDataArr = results
                .map((result: any) => ({
                    warningName: result.warningName,
                    totalRecords: result.alerts?.length || 0,
                    alerts: Array.isArray(result.alerts)
                        ? result.alerts.filter(
                            (alert: any) =>
                                result.warningName?.toLowerCase().includes(searchQuery.toLowerCase()) || 
                                alert?.vehicleNumber?.toLowerCase().includes(searchQuery.toLowerCase()) || 
                                alert?.device_id?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                                alert?.vehicleId?.toLowerCase().includes(searchQuery.toLowerCase())
                        )
                        : [],
                }))
                // .filter((result: any) => result.alerts.length > 0); // Keep only results with matching alerts
            const updatedResults = filteredDataArr.map(result => ({
                ...result,
                isCritical: criticalWarning.includes(result.warningName) // Check if warningName is in criticalWarning array
            }));
            console.log("Updated Results:", updatedResults);
            setNewData(updatedResults);

            return updatedResults;

        } catch (error) {
            setError(error instanceof Error ? error.message : 'Unknown error occurred');
            return [];
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (startDate && endDate) {
            fetchAllAlertsParallel(allWarningTypes);
        }
    }, [startDate, endDate, selectedDuration, searchQuery]);

    const formatTimestamp = (timestamp: string) => {
        const [year, month, day, hour, minute, second] = timestamp?.split('_');
        const date = new Date(
            `${year}-${month}-${day}T${hour}:${minute}:${second}`
        );
        return date.toLocaleDateString('en-GB', {
            day: 'numeric',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: true
        }).replace(',', '');
    };

    const getDateRange = (range: string) => {
        const today = dayjs();
        let startDate, endDate;

        switch (range) {
            case "Today":
                startDate = today.format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "Yesterday":
                startDate = dayjs().subtract(1, "day").format("YYYY-MM-DD");
                endDate = startDate;
                break;
            case "7 Days":
                startDate = dayjs().subtract(6, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "15 Days":
                startDate = dayjs().subtract(14, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            case "30 Days":
                startDate = dayjs().subtract(29, "day").format("YYYY-MM-DD");
                endDate = today.format("YYYY-MM-DD");
                break;
            default:
                startDate = "";
                endDate = "";
        }
        return { startDate, endDate };
    };
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
        setCalendarAnchorEl(event.currentTarget);
    };
    const handleCalendarClose = () => {
        setShowDatePicker(false);
        setStartDate("");
        // setStartTileDate("");
        // setEndTileDate("");
        setEndDate("");

        setSelectedDuration(dateRangeArr[0]);
        setCalendarAnchorEl(null);
    };
    const handleClose = (value?: string) => {
        console.log("Selected Value:", value);

        if (value) {
            setSelectedDuration(value);
            setShowDatePicker(value === "Custom Range");
            const { startDate: newStartDate, endDate: newEndDate } = getDateRange(value);
            setStartDate(newStartDate);
            // setStartTileDate(newStartDate);
            // setEndTileDate(newEndDate);
            setEndDate(newEndDate);
        }

        setAnchorEl(null);
    };

    const handleViewAll = (warning: any) => {
        const params = new URLSearchParams();
        const warningData: any = newData.find((item) => item.warningName === warning);
        console.log('startDate', startDate, endDate, warningData);
        
        params.set("warningName", warning);
        if (warningData) {
            params.set("isCritical", warningData.isCritical ? "true" : "false");
        }
        if (viewMode) {
            params.set("viewMode", viewMode);
        }
        if (startDate && endDate) {
            params.set("startDate", startDate);
            params.set("endDate", endDate);
        }
        if (selectedDuration) {
            params.set("selectedDuration", selectedDuration);
        }
        console.log("Trip Details:", params,tripDetails);

        navigate(`/trips/ignition/trip-all-alerts?${params.toString()}`, {state : { tripDetails: tripDetails}});
    };

    const [isCustomiseModalOpen, setIsCustomiseModalOpen] = useState(false);

    const handleCustomiseModalOpen = (event: any) => {
        setIsCustomiseModalOpen(true);
    };

    const handleFilterSave = (data: any) => {
        fetchAllAlertsParallel(allWarningTypes, data.group, data.vehicle);
    }
    const [tilesObj, setTilesObj] = useState<ColumnObjType>({
        Stat1: { name: "# Total Alerts", status: true },
        Stat2: { name: "# Critical Alerts", status: true },
        Stat3: { name: "Average alerts per device", status: true },
        Stat4: { name: "Average Alerts Per day", status: true },
    });
    const [columnObj, setColumnObj] = useState<ColumnObjType>({
        date_time: { name: "Date and Time", status: true },
        vehicleId: { name: "Vehicle Reg No", status: true },
        actions: { name: "Actions", status: true }
    });
    // useEffect(() => {
    //     handleTile(tilesObj)
    // }, [tilesObj])

    return (
        <Box className="text-gray-800 p-4">

            {/* Warnings List */}
            <Box className={`${viewMode === 'table' ? 'grid grid-cols-1 md:grid-cols-2 gap-4' : 'space-y-8'}`}>
                {newData?.map((warning: any, index) => (
                    <Box key={warning.warningName + index} className={`${viewMode === 'table' ? 'w-full bg-white rounded-lg shadow-sm' : 'space-y-4'}`}>
                        {/* Warning Header */}
                        <Box className="flex justify-between items-center bg-white p-2 rounded-lg">
                            <Box className="flex items-center gap-2">
                                <img src={getWarningIcon(warning.warningName)} />
                                <Typography
                                    variant="h6"
                                    className={`font-semibold ${warning.warningName === 'SOS' ? 'text-red-500' : ''}`}
                                    sx={{
                                        fontFamily: 'Inter Tight',
                                        fontWeight: 400,
                                        fontSize: '16px',
                                        lineHeight: '18px',
                                        letterSpacing: '0%',
                                        textTransform: 'uppercase',
                                        color: warning.warningName === 'SOS' ? 'red' : '#767676',
                                    }}
                                >
                                    {warning.warningName.toUpperCase()}
                                </Typography>
                                <img
                                    src={infoIcon}
                                    alt="info icon"
                                    title="More info"
                                    className="w-4 h-4 cursor-pointer"
                                />
                                <Chip
                                    label={warning.totalRecords || 0}
                                    size="small"
                                    sx={{
                                        width: 54,
                                        height: 24,
                                        gap: '10px',
                                        borderRadius: '4px',
                                        backgroundColor: '#EAE9F5',
                                        color: 'black'
                                    }}
                                />
                                <Box
                                    sx={{
                                        width: warning.isCritical ? 57 : 100,
                                        height: 24,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: warning.isCritical ? '10px' : '4px',
                                        borderRadius: '8px',
                                        padding: '4px 8px',
                                        backgroundColor: warning.isCritical ? '#F7E1E1' : '#FFF4E1',
                                    }}
                                >
                                    <Typography
                                        sx={{
                                            fontFamily: 'Inter Tight',
                                            fontWeight: 400,
                                            fontSize: '12px',
                                            lineHeight: '21px',
                                            letterSpacing: '0%',
                                            color: warning.isCritical ? '#C83333' : '#A9861E',
                                        }}
                                    >
                                        {warning.isCritical ? 'Critical' : 'Non Critical'}
                                    </Typography>
                                </Box>
                            </Box>
                            <Box className="flex justify-between items-center bg-white p-3 rounded-lg shadow-sm">
                                <Button
                                    variant="outlined"
                                    onClick={() => handleViewAll(warning.warningName)}
                                    endIcon={<CallMadeIcon />} // Add the CallMadeIcon here
                                >
                                    View All
                                </Button>
                            </Box>
                        </Box>

                        {/* Alerts Grid */}
                        {viewMode === 'grid' ? (
                            warning.alerts?.length > 0 ? (
                                <AlertsGrid alerts={warning.alerts} />
                            ) : (
                                <Box className="p-4 text-center text-gray-500">
                                    No records found for this warning
                                </Box>
                            )
                        ) : viewMode === 'table' ? (
                            warning.alerts?.length > 0 ? (
                                <AlertsTable alerts={warning.alerts} warning={warning.warningName} startDate={startDate} endDate={endDate} columnObj={columnObj} />
                            ) : (
                                <Box className="p-4 text-center text-gray-500">
                                    No records found for this warning
                                </Box>
                            )
                        ) : (
                            <Box className="p-4 text-center text-gray-500">
                                No alerts found for this warning type
                            </Box>
                        )}
                    </Box>
                ))}
            </Box>
            <FilterDataModel
                open={isFilterModel}
                onClose={handleFilterClose}
                handleFilterSave={handleFilterSave}
                title="Filter"
                description="Use the options below to refine your search and find specific trips quickly."
                showTripStatus={false}
            />
            <CustomiseTableModal
                open={isCustomiseModalOpen}
                onClose={() => setIsCustomiseModalOpen(false)}
                onReset={() => console.log("Reset clicked!")}
                title="Customize Your Table"
                description="Select and arrange table columns as you prefer."
                columnObj={columnObj}
                setColumnObj={setColumnObj}
                tilesObj={tilesObj}
                setTilesObj={setTilesObj}
            />
        </Box>
    );
};

export default TripAlerts;
